import { useTranslation } from "react-i18next";
import type { RespendConfirmation } from "../../api/hooks";
import { ConfirmDialog } from "./ConfirmDialog";

/**
 * The one retry that can cost money twice.
 *
 * A render or a Sample whose request died in flight leaves an attempt nobody
 * can resolve: ElevenLabs may have produced and charged for the audio, and its
 * history carries neither the text nor the voice, so the service cannot go and
 * look. The Author is the only one who can decide to pay for it again, and
 * this is where they say so. `useJobRetry` opens it on the service's refusal,
 * so a screen renders it and nothing else.
 */
export function RespendConfirmDialog({ state }: { state: RespendConfirmation | null }) {
  const { t } = useTranslation("components");
  return (
    <ConfirmDialog
      open={state !== null}
      title={t("respend.title")}
      confirmLabel={t("respend.confirm")}
      busy={state?.busy ?? false}
      onConfirm={() => state?.onConfirm()}
      onCancel={() => state?.onCancel()}
    >
      <p className="leading-relaxed text-ink-2">{t("respend.body")}</p>
    </ConfirmDialog>
  );
}
